/*
 * Copyright (c) 2023. American Express Company
 */

import React from 'react';
import { Tooltip as DLSTooltip } from '@americanexpress/dls-react';
import { TooltipViewModel } from 'src/types/view-models/dlsMods/tooltip.view.model';

const baseStyles = {
    minHeight: '44px',
    minWidth: '44px'
};

export default function Tooltip({
    className,
    triggerElement,
    children,
    id,
    info = false,
    placement = 'top',
    forcePlacement = false,
    theme
}: TooltipViewModel): JSX.Element {
    const combinedTheme = {
        ...baseStyles,
        ...theme
    };

    return (
        <div className={className}>
            <DLSTooltip
                id={id}
                triggerElement={triggerElement}
                info={info}
                placement={placement}
                forcePlacement={forcePlacement}
                theme={combinedTheme}
            >
                {children}
            </DLSTooltip>
        </div>
    );
}
